import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useRef } from "react";

export default function DirectTax() {
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab =
    location.pathname === "/direct-tax"
      ? "direct"
      : location.pathname === "/indirect-tax"
      ? "indirect"
      : "taxation";

  const handleTabClick = (path) => navigate(path);

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <>
      <Header />

      {/* HERO */}
      <section
        className="about-hero directtax-hero"
        style={{ backgroundImage: "url('/assets/img/Achievements.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text fade-in-up">
          <h1>Direct Tax (Income Tax)</h1>
          <p>Expert guidance and compliance support for income tax matters.</p>
        </div>
      </section>

      {/* TABS */}
      <div className="tax-tabs">
        <button
          className={activeTab === "taxation" ? "active" : ""}
          onClick={() => handleTabClick("/taxation-compliance")}
        >
          Taxation & Compliance
        </button>
        <button
          className={activeTab === "direct" ? "active" : ""}
          onClick={() => handleTabClick("/direct-tax")}
        >
          Direct Tax (Income Tax)
        </button>
        <button
          className={activeTab === "indirect" ? "active" : ""}
          onClick={() => handleTabClick("/indirect-tax")}
        >
          Indirect Tax (GST)
        </button>
      </div>

      {/* PROCESS SECTION */}
      <section className="audit-process container my-5">
        <h2>Our Direct Tax Process</h2>
        <div className="process-wrapper">
          <img
            src="/assets/img/directtax.png"
            alt="Direct Tax Process"
            className="audit-process-img"
          />
        </div>
      </section>

      {/* SLIDER SECTION */}
      <section className="container my-5 directtax-slider-wrap">
        {/* LEFT / RIGHT ARROWS */}
        <button ref={prevRef} className="slider-arrow slider-prev">
          ‹
        </button>
        <button ref={nextRef} className="slider-arrow slider-next">
          ›
        </button>

        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={1} // Change to 2 or 3 to show multiple cards
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          pagination={{ clickable: true }}
        >
          {/* SLIDE 1 */}
          <SwiperSlide>
            <div className="bf-main">
              {/* 1 */}
              <div className="bf-card">
                <h3>💼 GST Advisory & Structuring</h3>
                <p>
                  Classification, valuation, place of supply, and ITC advisory
                  for correct tax positions and optimal structuring.
                </p>
                <ul>
                  <li> HSN/SAC classification</li>
                  <li> Valuation & POS analysis</li>
                  <li> Transaction structuring</li>
                  <li> ITC optimization</li>
                </ul>
              </div>

              {/* 2 */}
              <div className="bf-card">
                <h3>📝 GST Registration & Changes</h3>
                <p>
                  Complete support for GST registration, amendments, additional
                  places of business, and cancellations.
                </p>
                <ul>
                  <li> New registrations</li>
                  <li> Amendments & updates</li>
                  <li> Revocation support</li>
                  <li> Multi-state registration</li>
                </ul>
              </div>

              {/* 3 */}
              <div className="bf-card">
                <h3>📋 GST Returns & Compliance</h3>
                <p>
                  Accurate, timely return filing with internal review and
                  controls to ensure complete compliance.
                </p>
                <ul>
                  <li> GSTR-1, 3B, 9/9C</li>
                  <li> QRMP support</li>
                  <li>Periodic reviews</li>
                  <li> Reconciliation support</li>
                </ul>
              </div>

              {/* 4 */}
              <div className="bf-card">
                <h3>🔍 Reconciliation & ITC Review</h3>
                <p>
                  Comprehensive reconciliation of books with GSTR-2B,
                  e-invoices, and mismatch resolution.
                </p>
                <ul>
                  <li> 2B vs books reconciliation</li>
                  <li> Mismatch analysis</li>
                  <li> Blocked credit review</li>
                  <li> ITC optimization strategies</li>
                </ul>
              </div>

              {/* 5 */}
              <div className="bf-card">
                <h3>📄 E-Invoicing & E-Way Bill</h3>
                <p>
                  Implementation support, exception handling, and process
                  controls for e-invoicing and e-way bills.
                </p>
                <ul>
                  <li> System integration</li>
                  <li> Exception tracking</li>
                  <li> Audit readiness</li>
                  <li> Process automation</li>
                </ul>
              </div>

              {/* 6 */}
              <div className="bf-card">
                <h3>⚖️ GST Notices, Audits & Appeals</h3>
                <p>
                  Expert drafting of replies and professional representation
                  before GST authorities and appellate forums.
                </p>
                <ul>
                  <li> Notices & submissions</li>
                  <li> Departmental audits</li>
                  <li> Appellate support</li>
                  <li> Litigation management</li>
                </ul>
              </div>
            </div>
          </SwiperSlide>

          {/* SLIDE 2 */}
          <SwiperSlide>
            <div className="bf-main">
              {/* 7 */}
              <div className="bf-card">
                <h3>🌍 Customs Classification & Valuation</h3>
                <p>
                  Expert HS classification, valuation review, and duty
                  optimization for import-export operations.
                </p>
                <ul>
                  <li> HSN classification</li>
                  <li> Valuation analysis</li>
                  <li> Duty impact review</li>
                  <li> Customs planning</li>
                </ul>
              </div>

              {/* 8 */}
              <div className="bf-card">
                <h3>🚢 Import–Export Compliance</h3>
                <p>
                  Comprehensive advisory on import-export procedures,
                  documentation, and regulatory requirements.
                </p>
                <ul>
                  <li> Import/export procedures</li>
                  <li> Documentation review</li>
                  <li> Compliance checks</li>
                  <li> Regulatory updates</li>
                </ul>
              </div>

              {/* 9 */}
              <div className="bf-card">
                <h3>🎯 Duty Exemptions & Incentives</h3>
                <p>
                  Strategic support under EPCG, Advance Authorisation, SEZ, and
                  EOU schemes for maximum benefits.
                </p>
                <ul>
                  <li> EPCG & AA schemes</li>
                  <li> SEZ / EOU advisory</li>
                  <li> Benefit tracking</li>
                  <li> Compliance monitoring</li>
                </ul>
              </div>

              {/* 10 */}
              <div className="bf-card">
                <h3>🔎 Customs Audits & SVB</h3>
                <p>
                  Professional handling of Special Valuation Branch matters and
                  comprehensive customs audits.
                </p>
                <ul>
                  <li> SVB proceedings</li>
                  <li> Customs audits</li>
                  <li> Investigation support</li>
                  <li> Valuation disputes</li>
                </ul>
              </div>

              {/* 11 */}
              <div className="bf-card">
                <h3>📜 Legacy Indirect Taxes</h3>
                <p>
                  Expert handling of Service Tax, VAT, and Excise disputes and
                  transition credit issues.
                </p>
                <ul>
                  <li> Legacy litigation</li>
                  <li> Transition credits</li>
                  <li> Pending demands</li>
                  <li> Closure support</li>
                </ul>
              </div>

              {/* 12 */}
              <div className="bf-card">
                <h3>🏭 Industry-Specific Advisory</h3>
                <p>
                  Sector-focused advisory for manufacturing, trading, real
                  estate, e-commerce, and specialized industries.
                </p>
                <ul>
                  <li> Works contracts</li>
                  <li> Stock transfers</li>
                  <li> E-commerce GST</li>
                  <li> Sector-specific solutions</li>
                </ul>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      <Footer />
    </>
  );
}
